const MOBILE_BREAKPOINT = 1024;

export default function initMobileNavigation() {
  const body = document.documentElement;
  const header = document.querySelector(".site-header");
  const navbar = document.querySelector(".site-header .navbar");
  const hamburger = document.querySelector(".site-header .hamburger-menu");

  if (!header || !navbar || !hamburger) return;

  // -----------------------------
  // Reset Menu
  // -----------------------------
  function resetMenu() {
    body.classList.remove("open-menu");
    navbar.classList.remove("open");
    hamburger.setAttribute("aria-expanded", "false");

    navbar.querySelectorAll(".submenu-open").forEach((item) => {
      item.classList.remove("submenu-open");
    });

    navbar.querySelectorAll(".accordion-open").forEach((item) => {
      item.classList.remove("accordion-open");
    });
  }

  // -----------------------------
  // Desktop Reset
  // -----------------------------
  function checkMode() {
    if (window.innerWidth > MOBILE_BREAKPOINT) {
      resetMenu();
    }
  }

  // -----------------------------
  // Hamburger
  // -----------------------------
  function toggleHamburger(e) {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    e.preventDefault();
    e.stopPropagation();

    const isOpening = !body.classList.contains("open-menu");

    if (!isOpening) {
      resetMenu();
      return;
    }

    body.classList.add("open-menu");
    navbar.classList.add("open");
    hamburger.setAttribute("aria-expanded", "true");
  }

  // -----------------------------
  // Main Accordion
  // -----------------------------
  function toggleMainMenu(e) {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    e.preventDefault();
    e.stopPropagation();

    const item = e.currentTarget.closest("li");

    navbar.querySelectorAll(":scope > ul > li.submenu-open").forEach((li) => {
      if (li !== item) {
        li.classList.remove("submenu-open");
        li.querySelectorAll(".accordion-open").forEach((acc) => {
          acc.classList.remove("accordion-open");
        });
      }
    });

    item.classList.toggle("submenu-open");
  }

  // -----------------------------
  // Inner Accordion
  // -----------------------------
  function toggleInnerMenu(e) {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    e.preventDefault();
    e.stopPropagation();

    const item = this.parentElement;
    const parent = item.parentElement;

    parent
      .querySelectorAll(":scope > .sub-menu-item.accordion-open")
      .forEach((el) => {
        if (el !== item) {
          el.classList.remove("accordion-open");
        }
      });

    item.classList.toggle("accordion-open");
  }

  // -----------------------------
  // Outside Click
  // -----------------------------
  document.addEventListener("click", (e) => {
    if (window.innerWidth > MOBILE_BREAKPOINT) return;

    if (!body.classList.contains("open-menu")) return;

    // Close only when clicking outside the header
    if (!header.contains(e.target)) {
      resetMenu();
    }
  });

  // -----------------------------
  // ESC Key
  // -----------------------------
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      resetMenu();
    }
  });

  // -----------------------------
  // Event Binding
  // -----------------------------
  hamburger.addEventListener("click", toggleHamburger);

  navbar.querySelectorAll(".mob-nav-arrow").forEach((icon) => {
    icon.addEventListener("click", toggleMainMenu);
  });

  navbar.querySelectorAll(".submenu-toggle").forEach((btn) => {
    btn.addEventListener("click", toggleInnerMenu);
  });

  // -----------------------------
  // Resize
  // -----------------------------
  let resizeTimer;

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(checkMode, 150);
  });

  checkMode();
}
